import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaChevronLeft, FaChevronRight, FaSignOutAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./Sidebar.css";

// Assets
import logo from "../assets/logo.png";
import inventoryIcon from "../assets/icons/InventoryIcon.svg";
import userIcon from "../assets/icons/user.svg";
import locationIcon from "../assets/icons/LocationIcon.svg";
import stocktakeIcon from "../assets/icons/merchandise.svg"; 
import accessRoleIcon from "../assets/icons/UserRoleIcon.svg";
import deploymentIcon from "../assets/icons/DeploymentIcon.svg";
import modelIcon from "../assets/icons/ModelIcon.svg";
import colorIcon from "../assets/icons/ColorVarianceIcon.svg";
import settingsicon from "../assets/icons/SettingsIcon.svg"; 
import ReportIcon from "../assets/icons/ReportIcon.svg";
import PartnerIcon from "../assets/icons/PartnerIcon.svg";

function Sidebar({ onSelect, hash: propHash }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  
  // Use hash from props if available, otherwise get from URL params
  const hash = propHash || params.hash;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin_id");
    localStorage.removeItem("permissions");
    alert("Logged out successfully!");
    navigate("/user");
  };

  const handleMenuClick = (section, path) => {
    console.log('handleMenuClick called:', { section, path, hash }); // Debug log
    
    if (path) {
      // Include the hash in the navigation path
      const fullPath = hash ? `/a/${hash}${path}` : path;
      console.log('Navigating to:', fullPath); // Debug log
      navigate(fullPath);
    } else if (onSelect) {
      // No path means we're selecting a dashboard section
      onSelect(section);
    }
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-logo">
        <img src={logo} alt="Company Logo" />
      </div>

      <button className="toggle-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      <ul>
        <li onClick={() => handleMenuClick("inventory", "")}>
          <img src={inventoryIcon} alt="Inventory" className="sidebar-icon" />
          {!isCollapsed && "Inventory"}
        </li>
        <li onClick={() => handleMenuClick("users", "")}>
          <img src={userIcon} alt="Users" className="sidebar-icon" />
          {!isCollapsed && "Users"}
        </li>
        <li onClick={() => handleMenuClick("Locations", "")}>
          <img src={locationIcon} alt="Locations" className="sidebar-icon" />
          {!isCollapsed && "Locations"}
        </li>
        <li onClick={() => handleMenuClick("Stocktake", "")}>
          <img src={stocktakeIcon} alt="Stocktake" className="sidebar-icon" />
          {!isCollapsed && "Stocktake"}
        </li>
        <li onClick={() => handleMenuClick("AccessRole", "")}>
          <img src={accessRoleIcon} alt="Access Role" className="sidebar-icon" />
          {!isCollapsed && "Access Role"}
        </li>
        <li onClick={() => handleMenuClick("Deployment", "")}>
          <img src={deploymentIcon} alt="Deployment" className="sidebar-icon" />
          {!isCollapsed && "Deployment"}
        </li>
        <li onClick={() => handleMenuClick("Report", "/reports")}>
          <img src={ReportIcon} alt="Report" className="sidebar-icon" />
          {!isCollapsed && "Report"}
        </li>

        {/* Setting Dropdown Group */}
        <li className="dropdown-container">
          <div className="dropdown-header" onClick={() => setIsModelOpen(!isModelOpen)}>
            <div className="dropdown-label">
              <img src={settingsicon} alt="Settings" className="sidebar-icon" />
              {!isCollapsed && <span>Setting</span>}
            </div>
            {!isCollapsed && (isModelOpen ? <FaChevronUp className="arrow-icon" /> : <FaChevronDown className="arrow-icon" />)}
          </div>

          {isModelOpen && !isCollapsed && (
            <ul className="sub-menu">
              <li className="sub-item" onClick={() => onSelect("Model")}>
                <img src={modelIcon} alt="Model" className="sidebar-icon sub-icon" style={{ width: '18px', marginRight: '10px' }} />
                Model List
              </li>
              <li className="sub-item" onClick={() => onSelect("Add colour")}>
                <img src={colorIcon} alt="Color" className="sidebar-icon sub-icon" style={{ width: '18px', marginRight: '10px' }} />
                Colour
              </li>
              <li className="sub-item" onClick={() => onSelect("Add partner")}>
                <img src={PartnerIcon} alt="Partner" className="sidebar-icon sub-icon" style={{ width: '18px', marginRight: '10px' }} />
                Partners
              </li>
            </ul>
          )}
        </li>
      </ul>

      <button className="logout-btn" onClick={handleLogout}>
        <FaSignOutAlt className="logout-icon" />
        {!isCollapsed && <span>Logout</span>}
      </button>
    </div>
  );
}

export default Sidebar;